module.exports = require('./timeformater');


/*****************
 ** WEBPACK FOOTER
 ** ../~/time-formater/index.js
 ** module id = 34
 ** module chunks = 0
 **/